import React from "react";
import { CasinoMaratonPlacements } from './CasinoMaratonPlacements.jsx'
import { CasinoMaratonResults } from './CasinoMaratonResults.jsx'
import { Game } from "../../Game/Game.jsx";

export class CasinoMaratonPrizeFund extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tabs: [ 'Popis igara','Nagrade', 'Poredak'],
            selectedTab: 'Popis igara',
        }

        this.renderIgra = this.renderIgra.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.info !== this.props.info) {
            this.setState({
                tabs: ['Popis igara','Nagrade', this.props.info.uplaceno ? 'Pobjednici' : 'Poredak']
            });
            casino.utils.lazyImages.mountEventLazyLoadImages();
        }
    }

    gotoTab(tab) {
        if (tab == 'Popis igara') setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0)
        this.setState({ selectedTab: tab });
    }

    dohvatiIgre() {

        if (this.props.info.igreSifre == null) {
            return [];
        }
        var utrkaIgraSifreArray = this.props.info.igreSifre.split(',');

        return this.props.games.filter(function (igra) {
            if (utrkaIgraSifreArray.includes(igra.s))
                return igra;
        });
    }

    renderPopisIgara() {
        return <div>
            <div id="game-container" className="maximum margin-center">
                <br></br>
                <div className={"clearfix white games-container"} style={(this.props.games) ? { padding: '0px' } : {}} >
                    {!this.props.games && <div>Dohvaćanje igara...</div>}
                    {this.props.games && this.dohvatiIgre().map(this.renderIgra)}
                </div>
            </div>
        </div>
    }

    renderIgra(igra, i) {
        return <Game
            brands={this.props.brands}
            categories={this.props.gameCategories}
            routePrefix={"/promotions/casino-maraton/"}
            key={igra.s} igra={igra}
            showJackpot={true}
            goLazyImage={true}
            fromNative={casino.config.fromNativeApp}
            fromNativeGameName={true}
            // GamePosition podaci, HizmanB
            PageName={"Promocije-{CasinoMaratonPrizeFund}"}
            GamePosition={i + 1}
            PositionType="lista_igara"
            IsIcon={false}
        />;
    }

    render() {
        return (
            <div className="casino-maraton-section">
                <h2 className="prize-fund-title">Nagradni fond u vrijednosti od <span className="red">{casino.utils.numberWithCurrencyFromated(50000, 'EUR')}</span></h2>
                <div className="row">
                    <span className="checkmark"></span>
                    <span className="prize-money">  <span className="red"> {casino.utils.numberWithCurrencyFromated(40000, 'EUR')}</span> se dijeli na sve sudionike Sprinta.</span>
                    <div className="clearfix"></div>
                </div>
                <div className="divider"></div>
                <div className="row">
                    <span className="checkmark"></span>
                    <span className="prize-money">  <span className="red"> {casino.utils.numberWithCurrencyFromated(10000, 'EUR')}</span> dijeli 30 najboljih SuperSkakača!</span>
                    <div className="clearfix"></div>
                </div>

                <div>
                    <div className="segment v2">
                        {this.state.tabs && this.state.tabs.map((tab) =>
                            <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                        )}
                    </div>
                    {this.state.selectedTab == 'Nagrade' && <CasinoMaratonPlacements {...this.props} />}
                    {(this.state.selectedTab == 'Poredak' || this.state.selectedTab == 'Pobjednici') && <CasinoMaratonResults {...this.props} />}
                    {this.state.selectedTab == 'Popis igara' && this.props.info && <div id="tabs">{this.renderPopisIgara()}</div>}
                </div>
                <a className="btn-rules" target="_blank" href={`${casino.config.casinoCDNDocumentsUrl}/Pravila/Brzinski_Super_Skok.pdf?c=${casino.config.guiCacheVerzija}`}>
                    <span>Pravila igre</span>
                </a>
                <p className="res-info">*<i>rezultati se osvježavaju svakih 5 minuta</i></p>
            </div>
        );

    }
}